import type { Maybe } from '@adornis/base/utilTypes.js';
import { LecturerContract } from '@adornis/buchungsheld-db/entities/LecturerContract.js';
import { Teaching } from '@adornis/buchungsheld-db/entities/teaching.js';
import { TrDialog } from '@adornis/buchungsheld-theme/components/tr-dialog.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import type { EntityPickerOptions } from '@adornis/entity-picker/client/entity-picker-options.js';
import '@adornis/entity-picker/client/x-entity-picker.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { StringAspect } from '@adornis/filter/aspect-schemas/StringAspect.js';
import { FormController } from '@adornis/forms/x-form-controller.js';
import '@adornis/forms/x-input.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

/*
 * @element bh-prompt-admin-manage-lecturer-contract-on-product
 */
@customElement('bh-prompt-admin-manage-lecturer-contract-on-product')
export class BhPromptAdminManageLecturerContractOnProduct extends TrDialog<void> {
  static override get element_name() {
    return 'bh-prompt-admin-manage-lecturer-contract-on-product';
  }

  @property({ attribute: false }) institutionID?: string;
  @property({ attribute: false }) teaching = new RXController<null | Teaching>(this, null);

  @state() private _form = new FormController(this, this.teaching.observable);

  override content() {
    if (this.teaching.isLoading) return html` <tr-loading-state></tr-loading-state> `;
    if (!this.teaching.value || !this.institutionID) return html` 404 - Not found `;
    return html`
      <x-flex space="md">
        <x-h2> Vertrag verwalten </x-h2>
        <x-entity-picker
          ${this._form.field('contractID')}
          placeholder="Vertrage auswählen..."
          .options=${{
            class: LecturerContract,
            filter: new AdornisFilter({
              searchFields: ['title'],
              aspects: [new StringAspect({ fieldName: 'institutionID', mode: 'equals', value: this.institutionID })],
            }),
            selectionSet: { title: 1 },
          } satisfies EntityPickerOptions<typeof LecturerContract>}
          .renderString=${(contract: Maybe<LecturerContract>) => contract?.title}
        ></x-entity-picker>
        <x-input type="number" postfix="&euro;" placeholder="Vergütung" ${this._form.field('contractPrice')}></x-input>
        <x-input placeholder="Vergütung (ausgeschrieben)" ${this._form.field('contractPriceWords')}></x-input>
        <x-flex horizontal end> <x-button @click=${() => this.close()}> Schließen </x-button> </x-flex>
      </x-flex>
    `;
  }
}
